'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _jsxFileName = 'src/SureDesignSystem/Button/Button.js';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Link = require('../Link');

var _Link2 = _interopRequireDefault(_Link);

var _ButtonModule = require('./Button.module.css');

var _ButtonModule2 = _interopRequireDefault(_ButtonModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var propTypes = {
  to: _propTypes2.default.string,
  type: _propTypes2.default.string,
  icon: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  className: _propTypes2.default.string,
  iconClassName: _propTypes2.default.string,
  secondary: _propTypes2.default.bool,
  children: _propTypes2.default.node.isRequired
};
var defaultProps = {
  type: 'button',
  icon: null,
  onClick: null,
  className: null,
  iconClassName: null,
  secondary: false
};

function Button(_ref) {
  var to = _ref.to,
      type = _ref.type,
      icon = _ref.icon,
      onClick = _ref.onClick,
      className = _ref.className,
      iconClassName = _ref.iconClassName,
      secondary = _ref.secondary,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['to', 'type', 'icon', 'onClick', 'className', 'iconClassName', 'secondary', 'children']);

  var Icon = icon;
  var buttonClassName = (0, _classnames2.default)(_ButtonModule2.default.button, _defineProperty({}, _ButtonModule2.default.secondary, secondary), className);

  var buttonChildren = _react2.default.createElement(_react2.default.Fragment, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47
    },
    __self: this
  }, Icon && _react2.default.createElement(Icon, {
    className: (0, _classnames2.default)(_ButtonModule2.default.icon, iconClassName),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48
    },
    __self: this
  }), children);

  if (to) {
    return _react2.default.createElement(_Link2.default, _extends({}, props, {
      to: to,
      onClick: onClick,
      className: buttonClassName,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55
      },
      __self: this
    }), buttonChildren);
  } else {
    return _react2.default.createElement('button', _extends({}, props, {
      type: type,
      onClick: onClick,
      className: buttonClassName,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 61
      },
      __self: this
    }), buttonChildren);
  }
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
exports.default = Button;